/* eslint-disable camelcase */
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';

import { RoleIcon } from '../RoleIcon';
import RoleDetailCard from '../RoleDetailCard';
import { updateField } from '../../../../actions/BookingRequest';
import { TRootState } from '../../../../reducers';
import { TServiceKey } from '../../../../types';

type TAgentRoleCard = {
    className?: string;
    mode: string;
    isMultiService: boolean;
    setIsMultiService: (checked: boolean) => void;
    selectedServices: TServiceKey[];
    handleSetSelectedServices: (services: TServiceKey[]) => void;
    setErrorMessage: (message: string) => void;
};

export function AgentRoleCard({
    className,
    mode,
    isMultiService,
    setIsMultiService,
    selectedServices,
    handleSetSelectedServices,
    setErrorMessage,
}: TAgentRoleCard) {

    const {
        roleData,
        service,
        servicesStructure,
        maxNumOfServices,
    } = useSelector(
        (state: TRootState) => ({
            roleData: state.requestData.roleData,
            service: state.requestData.bookingRequest.service,
            servicesStructure: state.servicesStructure,
            maxNumOfServices: state.user.agency.max_services_per_multiservice_job,
        }),
    );

    const dispatch = useDispatch();

    const handleRoleFieldClick = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            dispatch(updateField('service', e.target.value));
        },
        [dispatch],
    );

    const handleMultiServiceChange = (checked: boolean) => {
        setIsMultiService(checked);

        if (!checked) {
            handleSetSelectedServices([]);
            dispatch(updateField('additional_services', []));
        }
    };

    const handleAddService = () => {
        if (selectedServices.length >= maxNumOfServices) {
            setErrorMessage(`You can only select up to ${maxNumOfServices} services.`);
            return;
        }
        if (!selectedServices.includes(service)) {
            handleSetSelectedServices([...selectedServices, service]);
        }
    };

    const roleItemClassName = `role-item service-role-item${mode === 'edit' ? ' disabled' : ''}`;

    const renderRoleIcons = () => {
        if (servicesStructure) {
            return Object.entries(servicesStructure)
                .filter(([serviceKey]) => !!serviceKey)
                .map(([serviceKey, serviceData]) =>
                    <RoleIcon
                        key={serviceKey}
                        value={serviceKey}
                        handleChange={handleRoleFieldClick}
                        roleItemClassName={roleItemClassName}
                        name={serviceData.label}
                        iconName={serviceData.icon_name}
                        service_key={service}
                        mode={mode}
                    />
                );
        }
        return null;
    };

    return (
        <div className={classNames('card card-role card-role-main', className)}>
            <div className="card-content">
                <div className="card-title">
                    Service
                </div>
                <div className="multiservice-checkbox">
                    <label>
                        <input
                            className="margin-5-px opacity-1 checkbox-purple"
                            type="checkbox"
                            name="multiservice"
                            // @ts-ignore
                            checked={isMultiService}
                            onChange={event =>
                                handleMultiServiceChange(event.target.checked)}
                            disabled={mode === 'edit'}
                        />
                        Multisector job?
                    </label>
                </div>
                <form>
                    {renderRoleIcons()}
                </form>
                <RoleDetailCard
                    className="agent-role-detail"
                    service_key={service}
                    roleData={roleData}
                    mode={mode}
                />
                {isMultiService && mode !== 'edit' && (
                    <div className="modal-bottom-bar">
                        <button
                            className="table-action-button"
                            type="button"
                            disabled={selectedServices.includes(service)}
                            onClick={handleAddService}
                        >
                            ADD SERVICE
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}
